import { render } from "./WeekdayImageGallery.vue?vue&type=template&id=20694bec&scoped=true"
import script from "./WeekdayImageGallery.vue?vue&type=script&lang=js"
export * from "./WeekdayImageGallery.vue?vue&type=script&lang=js"

import "./WeekdayImageGallery.vue?vue&type=style&index=0&id=20694bec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20694bec"]])

export default __exports__